import React, { useEffect, useRef, useState } from 'react';

const VideoPlayer = ({ videoRef, videoSrc }) => {
    return (
        <video
            className='w-full object-fill object-top bg-black'
            src={videoSrc}
            ref={videoRef}
            loop
        />
    )
};

export default VideoPlayer;